import ArrowRightSvg from '@remote-com/norma/icons/arrow-right.svg';
import ChevronRightSvg from '@remote-com/norma/icons/chevron-right.svg';
import { forwardRef } from 'react';
import { sharedTransition } from 'remote-com-shared/style/motion';
import styled, { keyframes, css } from 'styled-components';
// Icons

// Helpers

export const ArrowIcon = styled(ArrowRightSvg)``;
export const ChevronIcon = styled(ChevronRightSvg)``;

export const ChevronHoverAnimation = keyframes`
  0% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(30%);
  }
`;

export const StyledButton = styled.button`
  color: var(--colors-irisBlue);
  background: transparent;
  border: none;
  margin-right: 0;
  padding: 0;
  display: inline-flex;
  align-items: center;
  font-size: 18px;

  :hover {
    ${ChevronIcon} {
      transform: translateX(30%);
    }
    ${ArrowIcon} {
      transform: translateX(30%);
    }
  }

  ${ArrowIcon} {
    ${sharedTransition(`transform`)}
    fill: var(--colors-irisBlue);
    height: 18px;
    transform: translateX(0%);
  }

  ${ChevronIcon} {
    ${sharedTransition(`transform`)}
    fill: var(--colors-turquoise);
    height: 18px;
    margin-left: 10px;
    margin-right: -10px;
    transform: translateX(0%);
  }

  // Download Icon

  ${(props) =>
    props.download &&
    css`
      ${ArrowIcon} {
        transform: rotate(90deg);
      }
    `}

  ${(props) =>
    props.before &&
    css`
      flex-direction: row-reverse;

      ${ArrowIcon} {
        padding-top: 12px;
      }
    `}

  // Text color

  ${(props) =>
    props.textWhite &&
    css`
      color: var(--colors-blank);
    `}

  // Button background

  ${(props) =>
    props.withBackground &&
    css`
      padding: 13px 32px;
      border-radius: 50px;
      font-weight: 500;
      font-size: 16px;
      line-height: 19px;
    `}


  ${(props) =>
    props.irisBlueBG &&
    css`
      background: var(--colors-irisBlue);
      color: var(--colors-blank);
      box-shadow: 0px 6px 12px ${({ theme }) => theme.colors.irisBlue_30};
    `}

  // With Border

  ${(props) =>
    props.withBorder &&
    css`
      font-size: 16px;
      border: 1px solid var(--colors-blank);
    `}

  ${({ borderWidth }) =>
    borderWidth &&
    css`
      border-width: ${borderWidth};
    `}
    
  ${({ textColor }) =>
    textColor &&
    css`
      color: ${textColor};
    `}

  ${({ borderColor }) =>
    borderColor &&
    css`
      border-color: var(--colors-${borderColor});
    `}

  // Arrow/chevron animation
  
  ${({ animation }) =>
    animation &&
    css`
      svg {
        margin-left: 16px;
        ${sharedTransition('transform')}
      }

      &:hover {
        svg {
          transform: translateX(5px);
        }
      }
    `}
`;

const LinkButton = forwardRef(function LinkButton({ href, label, ...props }, ref) {
  return href ? (
    <StyledButton as="a" href={href} ref={ref} {...props}>
      {label}
      {props.arrow && <ArrowIcon />}
      {props.chevron && <ChevronIcon />}
    </StyledButton>
  ) : (
    <StyledButton type="button" {...props}>
      {label}
      {props.arrow && <ArrowIcon />}
      {props.chevron && <ChevronIcon />}
    </StyledButton>
  );
});

export default LinkButton;
